import React, { useState, useEffect } from 'react'
import '../styles/home.css';
import Form from '../components/Form';
import Review from '../components/Review';
import WorkCarousel from '../components/WorkCarousel';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import EmailSent from '../components/EmailSent';
import OurWorkMobile from '../components/OurWorkMobile';


export const Home = () => {




    return (
        <div id='home-main'>
            <Helmet>
                <title>Alpha Builders</title>
                <meta property="og:title" content="Alpha Builders Seattle Home Remodeling Experts" />
                <meta name="description" content="Alpha Builders Seattle's trusted home remodeler, delivering expert renovations with quality craftsmanship and personalized service. Transform your space today!" />
                <meta name="keywords" content="alpha builders, home remodeling, kitchen remodeling, flooring services, roofing services, " />
                <meta property="og:image" content="/favicon.ico" />
                <meta property="og:url" content="https://alphabuilders-wa.com/" />
                <meta property="og:type" content="website" />
            </Helmet>

            {/* <header id="home-header2">

                <div id='hh2-inner'>

                    <div id='call-to-action'>
                        <div id='header-content-inner2'>



                            <div>

                                <h1 className='brass-text-gradient' id='alph'>ALPHA BUILDERS</h1>
                            </div>

                        </div>



                        <h1 id='ca-h1'>CRAFTING EXCELLENCE</h1>
                        <h2 id='ca-h2'>BUILDING DREAMS</h2>
                        <p>General Contractor Serving Western and Central Washington</p>

                        <div className='brass-gradient' id='call-line'></div>

                        <Link to="/contact">
                            <button id='get-in-touch'>Get In Touch</button>
                        </Link>

                    </div>

                    <img src='images/trees-bg-wg.png' id='trees-wc' />

                    <img id='house-pic' src='images/house-picg.png' />

                </div>


              
            </header> */}

            <header className="site-hero" style={{ backgroundImage: `url('images/header-photo.jpg')` }}>
                <div className="site-hero-overlay"></div>

                <div className="site-hero-layout">
                    <div className="site-hero-content">
                        <p className="hero-eyebrow">Western Washington Remodeling</p>
                        <h1>Built With Craft. Designed To Last.</h1>
                        <p className="hero-subtext">
                            Remodeling, carpentry, flooring, tile, kitchens, bathrooms, and exterior work
                            delivered with detail-driven craftsmanship.
                        </p>

                        <div className="hero-buttons">
                            <a href="/contact" className="brass-gradient hero-btn hero-btn-prim">Get a Quote</a>
                            <a href="/portfolio" className="hero-btn hero-btn-secondary">View Our Work</a>
                        </div>
                    </div>

                    <div className="hero-visual-panel">
                        <img src="project-images/1.jpg" alt="Remodeling project" />
                        <div className="hero-visual-info">
                            <p>Custom Remodeling</p>
                            <h3>Built around quality materials and clean finish work.</h3>
                        </div>
                    </div>
                </div>
            </header>

            <main>



                <section id='home-about-intro'>
                    <div id='hai'>
                        <img id='hai-img' src='images/logo-2.png' alt='alpha builders logo' />




                        <div id='hai-txt'>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '10px' }}>
                                <div>
                                    <a style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '5px' }} href='#home-form'>
                                        <img style={{ width: '30px' }} src='/images/cons-icon.png' alt='facebook icon' />
                                        <h3>FREE CONSULTATION</h3>

                                    </a>


                                </div>

                                <div>
                                    <a style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '5px' }} href='https://www.facebook.com/profile.php?id=61566555421586' target='_blank'>
                                        <img style={{ width: '30px' }} src='/images/fb.png' alt='facebook icon' />
                                        <h3>FOLLOW US</h3>




                                    </a>

                                </div>



                            </div>



                            <div className='hai-line brass-gradient'></div>
                            <p>Alpha Builders is a trusted remodeling and renovation company based in Renton, Washington. We proudly serve Seattle, the Puget Sound region, and Central Washington. From kitchen and bathroom remodels to flooring and custom carpentry, our team delivers high-quality craftsmanship for every project. </p>
                            <Link to="/about">
                                <button>Learn More</button>
                            </Link>
                        </div>


                        {/* <div className='bp-bg-h'>
                            <div className='bp-bg-text'>
                                <h3 className='planwus'>PLAN WITH US</h3>
                                <h4>Schedule a free and risk free consultation</h4>

                                <Link to="/contact">
                                    <button>SCHEDULE</button>
                                </Link>

                            </div>
                            <img id='blue-print-h' src='images/bp-3.png' alt='blue print' />
                        </div> */}



                    </div>

                    <div id='hai-quick-links'>

                        <div className='hai-f'>
                            <div className='hai-ql '>

                                <Link to='/portfolio'>
                                    <img src='images/portfolio.png' alt='alpha builders portfolio' />
                                    <h3>PORTFOLIO</h3>
                                </Link>

                            </div>
                        </div>

                        <div className='hai-f'>
                            <div className='hai-ql '>

                                <a href="#home-s3">
                                    <img src='images/reviews.png' alt='alpha builders reviews' />
                                    <h3>REVIEWS</h3>
                                </a>

                            </div>
                        </div>

                        <div className='hai-f'>
                            <div className='hai-ql '>

                                <Link to='/services'>
                                    <img src='images/services.png' alt='alpha builders services' />
                                    <h3>SERVICES</h3>
                                </Link>

                            </div>
                        </div>

                    </div>

                </section>

                <section id="home-s1">
                    <div id="home-s1-content">

                        <div id="hm-s1-1">


                            <div id="abt-us">

                                <h2>OUR SERVICES</h2>

                            </div>
                            <div id="home-s1-cards">
                                <div className="card-format">
                                    <div className="home-s1-card">
                                        <img src="images/remodel-icon.png" alt='alpha builders remodels' />
                                        <h3>REMODELS</h3>


                                    </div>
                                </div>

                                <div className="card-format">
                                    <div className="home-s1-card">
                                        <img src="images/tiles-icon.png" alt='alpha builders tiles' />
                                        <h3>TILES</h3>
                                    </div>
                                </div>

                                <div className="card-format">
                                    <div className="home-s1-card">
                                        <img src="images/floor-icon.png" alt='alpha builders flooring' />
                                        <h3>FLOORING</h3>
                                    </div>
                                </div>


                                <div className="card-format">
                                    <div className="home-s1-card">
                                        <img src="images/kitchen-icon.png" alt='alpha builders kitchen renovation' />
                                        <h3>KITCHEN</h3>
                                    </div>
                                </div>


                                <div className="card-format">
                                    <div className="home-s1-card">
                                        <img src="images/roof.png" alt='alpha builders roofing' />
                                        <h3>ROOFING</h3>
                                    </div>
                                </div>

                                <div className="card-format">
                                    <div className="home-s1-card">
                                        <img src="images/bathroom.png" alt='alpha builders bathroom renovation' />
                                        <h3>BATHROOM</h3>
                                    </div>
                                </div>


                                <div className="card-format">
                                    <div className="home-s1-card">
                                        <img src="images/carpentry.png" alt='alpha builders carpentry' />
                                        <h3>CARPENTRY</h3>
                                    </div>
                                </div>


                                <div className="card-format">
                                    <div className="home-s1-card">
                                        <img src="images/drywall.png" alt='alpha builders drywall' />
                                        <h3>DRYWALL</h3>
                                    </div>
                                </div>


                                <div className="card-format">
                                    <div className="home-s1-card">
                                        <img src="images/paint.png" alt='alpha builders paint' />
                                        <h3>PAINTING</h3>
                                    </div>
                                </div>


                                <div className="card-format">
                                    <div className="home-s1-card">
                                        <img src="images/fence-icon2.png" alt='alpha builders paint' />
                                        <h3>FENCES</h3>
                                    </div>
                                </div>

                                <div className="card-format">
                                    <div className="home-s1-card">
                                        <img src="images/deck-icon.png" alt='alpha builders paint' />
                                        <h3>DECKING</h3>
                                    </div>
                                </div>


                                <div className="card-format">
                                    <div className="home-s1-card">
                                        <img src="images/home-addition.png" alt='alpha builders paint' />
                                        <h3>HOME ADDITIONS</h3>
                                    </div>
                                </div>


                            </div>


                        </div>

                    </div>
                </section>


                {/* <section id="home-s2" style={{ backgroundImage: `url('images/tb-6.jpg')`, backgroundSize: 'cover', backgroundPosition: 'center' }}>

                </section> */}


                <section
                    id="home-s2"
                    className="home-projects-section"
                    style={{
                        backgroundImage: `linear-gradient(rgba(12, 10, 8, 0.72), rgba(12, 10, 8, 0.58)), url('images/tb-6.jpg')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                >
                    <div className="home-projects-content">
                        <div className="home-projects-text">
                            <span className="section-kicker">Recent Work</span>
                            <h2>Built with care, detail, and craftsmanship.</h2>
                            <p>
                                From decks and outdoor structures to custom builds and finishing work,
                                Alpha Builders brings practical experience and clean execution to every project.
                            </p>

                            <Link to="/portfolio" className="projects-link brass-gradient">
                                View Project Gallery
                            </Link>
                        </div>

                        <div className="project-preview-grid">
                            <Link to="/portfolio" className="project-preview-card tall">
                                <img src="project-images/11.jpg" alt="Front porch remodel project" />
                                <div className="project-card-overlay">
                                    <span>Porches & Entryways</span>
                                </div>
                            </Link>

                            <Link to="/portfolio" className="project-preview-card">
                                <img src="project-images/6.jpg" alt="Covered outdoor structure project" />
                                <div className="project-card-overlay">
                                    <span>Outdoor Structures</span>
                                </div>
                            </Link>

                            <Link to="/portfolio" className="project-preview-card">
                                <img src="project-images/15.jpg" alt="Custom wood storage project" />
                                <div className="project-card-overlay">
                                    <span>Custom Builds</span>
                                </div>
                            </Link>
                        </div>
                    </div>
                </section>










                <section id="home-s3">
                    <h2 id='review-from-clients2'>REVIEWS FROM CLIENTS</h2>

                    <Review />

                </section>


                <div id='stats-and-form'>








                    <section id='stats' style={{ backgroundImage: `url('images/tb-6.jpg')`, backgroundSize: 'cover', backgroundPosition: 'center' }}>

                        <div id='ti2-cards'>

                            <div className='ti2-format '>

                                <div className='ti2-card brass-gradient'>

                                    <div className='ti2-card-top brass-gradient-wshimmer'>
                                        <svg
                                            className="stat-card-svg"
                                            data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 461.47 510.35">
                                            <path className="stat-card-fill" d="M456.73,84.35V594.7H918.2V84.35ZM810.9,529.47,687.46,464.58,564,529.47,587.61,392l-99.86-97.34,138-20.05,61.71-125,61.72,125,138,20.05L787.32,392Z" transform="translate(-456.73 -84.35)" />
                                        </svg>
                                    </div>
                                    <div className='ti2-card-btm'>
                                        <h3>4.8</h3>
                                        <h4>Average Rating</h4>
                                    </div>

                                </div>

                            </div>

                            <div className='ti2-format'>
                                <div className='ti2-card brass-gradient'>

                                    <div className='ti2-card-top brass-gradient-wshimmer'>
                                        <svg
                                            className="stat-card-svg"
                                            data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 461.47 510.35">

                                            <path className="stat-card-fill" d="M681.09,153.71a6.31,6.31,0,1,1,7,6.28c-.24,0-.47,0-.71,0s-.48,0-.71,0A6.31,6.31,0,0,1,681.09,153.71Z" transform="translate(-456.73 -93.53)" />
                                            <path className="stat-card-fill" d="M750.37,191.34v5.78h-126v-5.78H555.07V537.63H819.31V191.34ZM680,398.83l-42.66-42.66,11.35-11.35L680,376.13l69-69,11.36,11.35Z" transform="translate(-456.73 -93.53)" />
                                            <path className="stat-card-fill" d="M456.73,93.53V603.88H918.2V93.53ZM830,549.74a6.13,6.13,0,0,1-6.14,6.14H551.1a6.14,6.14,0,0,1-6.14-6.14V186.08a6.14,6.14,0,0,1,6.14-6.14h73.34A20.8,20.8,0,0,1,645.22,160h16.17a26.76,26.76,0,0,1,52,0h16.18a20.79,20.79,0,0,1,20.77,19.95h73.46a6.13,6.13,0,0,1,6.14,6.14Z" transform="translate(-456.73 -93.53)" />
                                        </svg>
                                    </div>
                                    <div className='ti2-card-btm'>
                                        <h3>74</h3>
                                        <h4>Completed Projects</h4>
                                    </div>

                                </div>
                            </div>



                            <div className='ti2-format'>
                                <div className='ti2-card brass-gradient'>

                                    <div className='ti2-card-top brass-gradient-wshimmer'>
                                        <svg className="stat-card-svg" data-name="Layer 1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 461.46 510.34">
                                            <path className="stat-card-fill" d="M862.72,348.8a174.42,174.42,0,0,1-56.79,129l-.3.28A128.1,128.1,0,0,0,715,402.8a71.47,71.47,0,1,0-54.56,0,128.07,128.07,0,0,0-90.63,75.31l-.3-.28a175,175,0,0,1,118.22-304C784.38,173.79,862.72,252.16,862.72,348.8Z" transform="translate(-457 -93.76)" />
                                            <path className="stat-card-fill" d="M457,93.76V604.1H918.46V93.76ZM821,494.43a197.36,197.36,0,0,1-330.67-145.5c0-109,88.34-197.37,197.37-197.37s197.35,88.38,197.35,197.37A196.65,196.65,0,0,1,821,494.43Z" transform="translate(-457 -93.76)" />
                                        </svg>
                                    </div>
                                    <div className='ti2-card-btm'>
                                        <h3>74</h3>
                                        <h4>Satisfied Clients</h4>
                                    </div>

                                </div>

                            </div>




                        </div>
                    </section>



                    <div>
                        <section id="process">

                            <div id='process-lbl'>
                                <img src="images/gear.png" alt='gear' />
                                <div id='process-lbl-text'>
                                    <h2 style={{ marginBottom: '5px' }}>HOW WE GET THINGS DONE</h2>
                                    <p>Our Process</p>

                                </div>

                            </div>


                            <div id="process-chart">

                                <div id="process-line"></div>



                                <div className="chart-circle">
                                    <span>1</span>
                                </div>

                                <span className="process-step">Reach Out</span>

                                <div className="chart-circle">
                                    <span>2</span>
                                </div>

                                <span className="process-step">Recieve Consultation</span>


                                <div className="chart-circle">
                                    <span>3</span>
                                </div>

                                <span className="process-step">Schedule Project</span>


                                <div className="chart-circle">
                                    <span>4</span>
                                </div>

                                <span className="process-step">Project Completion</span>


                                <div className="chart-circle">
                                    <img src="images/check-mark.png" height="20px" alt='check mark' />
                                </div>

                            </div>



                            <div id='mobile-process-cont'>

                                <div id="process-chart2">




                                    <div className='mobile-process-step'>
                                        <div className="chart-circle">
                                            <span>1</span>
                                        </div>
                                        <span className="process-step">Reach Out</span>
                                    </div>



                                    <div className='mobile-process-step'>
                                        <div className="chart-circle">
                                            <span>2</span>
                                        </div>

                                        <span className="process-step">Recieve Consultation</span>

                                    </div>


                                    <div className='mobile-process-step'>
                                        <div className="chart-circle">
                                            <span>3</span>
                                        </div>

                                        <span className="process-step">Schedule Project</span>
                                    </div>


                                    <div className='mobile-process-step'>

                                        <div className="chart-circle">
                                            <span>4</span>
                                        </div>

                                        <span className="process-step">Project Completion</span>


                                    </div>





                                </div>

                            </div>


                        </section>



                        <section id="home-form">
                            <Form />

                        </section>

                    </div>









                </div>




            </main>

            {/* <img src='images/house-graphic-long.png' style={{ width: '100%' }} /> */}

        </div >


    )
}
